import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllNewsletterEmailsService = (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.newsLetter.getAllNewsletterEmails}?page=${page}&limit=${limit}`
  );
};
const DeleteNewsletterEmailService = (emailId: number) => {
  return HTTP_CLIENT.delete(
    `${Endpoint.newsLetter.deleteNewsletterEmail}/${emailId}`
  );
};

export { GetAllNewsletterEmailsService, DeleteNewsletterEmailService };
